import { render, staticRenderFns } from "./countdown.vue?vue&type=template&id=5c506389&scoped=true"
import script from "./countdown.vue?vue&type=script&lang=js"
export * from "./countdown.vue?vue&type=script&lang=js"
import style0 from "./countdown.vue?vue&type=style&index=0&id=5c506389&prod&lang=css&scoped=true"
import style1 from "./countdown.vue?vue&type=style&index=1&id=5c506389&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c506389",
  null
  
)

export default component.exports